export default "__VITE_ASSET__BM0q$pz___"